import type { LineupEntry } from 'stores/base-types'

// Helper function to generate 9 dummy batters
// noinspection JSUnusedGlobalSymbols
export const generateDummyLineup = (): LineupEntry[] => {
  const lineup: LineupEntry[] = []
  for (let i = 1; i <= 9; i++) {
    const pos = i<=9 ? i : 13
    lineup.push({
      player: {
        id: i, // Updated to number instead of a string
        name: `Player ${i}`,
        uniformNumber: i * 5, // Just giving them random uniform numbers like 5, 10, 15...
        bats: 'R', // Defaulting to Right-handed
        throws: 'R', // Defaulting to Right-handed
      },
      battingOrder: i,
      startingPosition: pos, // Conveniently, 1-9 maps perfectly to standard defensive positions!
      substitutions: [], // Initialized as an empty array to satisfy the type requirement
    })
  }
  return lineup
}

export const generateRocksLineup = (): LineupEntry[] => {
  const rocks: LineupEntry[] = [
    {
      "player": {
        "id": 1782232477934,
        "name": "Jamo",
        "uniformNumber": 16,
        "bats": "R",
        "throws": "R",
        "primaryPosition": 9,
        "primaryBattingOrder": 1
      },
      "battingOrder": 1,
      "startingPosition": 9,
      "substitutions": []
    },
    {
      "player": {
        "id": 1787515343212,
        "name": "Asher ",
        "uniformNumber": 7,
        "bats": "R",
        "throws": "L",
        "primaryPosition": 13,
        "primaryBattingOrder": 2
      },
      "battingOrder": 2,
      "startingPosition": 13,
      "substitutions": []
    },
    {
      "player": {
        "id": 1782232456437,
        "name": "Carter",
        "uniformNumber": 3,
        "bats": "R",
        "throws": "R",
        "primaryPosition": 13,
        "primaryBattingOrder": 3
      },
      "battingOrder": 3,
      "startingPosition": 4,
      "substitutions": []
    },
    {
      "player": {
        "id": 1782232469250,
        "name": "Zeke",
        "uniformNumber": 5,
        "bats": "R",
        "throws": "R",
        "primaryPosition": 2,
        "primaryBattingOrder": 4
      },
      "battingOrder": 4,
      "startingPosition": 13,
      "substitutions": []
    },
    {
      "player": {
        "id": 1787508498212,
        "name": "Cooper",
        "uniformNumber": 23,
        "bats": "L",
        "throws": "R",
        "primaryPosition": 7,
        "primaryBattingOrder": 5
      },
      "battingOrder": 5,
      "startingPosition": 2,
      "substitutions": []
    },
    {
      "player": {
        "id": 1782232475634,
        "name": "E",
        "uniformNumber": 1,
        "bats": "R",
        "throws": "R",
        "primaryPosition": 3,
        "primaryBattingOrder": 6
      },
      "battingOrder": 6,
      "startingPosition": 6,
      "substitutions": []
    },
    {
      "player": {
        "id": 1782232459386,
        "name": "Nolan",
        "uniformNumber": 9,
        "bats": "R",
        "throws": "R",
        "primaryPosition": 13,
        "primaryBattingOrder": 7
      },
      "battingOrder": 7,
      "startingPosition": 8,
      "substitutions": []
    },
    {
      "player": {
        "id": 1782232487241,
        "name": "Logan",
        "uniformNumber": 8,
        "bats": "R",
        "throws": "R",
        "primaryPosition": 8,
        "primaryBattingOrder": 8
      },
      "battingOrder": 8,
      "startingPosition": 1,
      "substitutions": []
    },
    {
      "player": {
        "id": 1787508526120,
        "name": "Cal",
        "uniformNumber": 21,
        "bats": "R",
        "throws": "R",
        "primaryPosition": 10,
        "primaryBattingOrder": 9
      },
      "battingOrder": 9,
      "startingPosition": 3,
      "substitutions": []
    },
    {
      "player": {
        "id": 1787508402963,
        "name": "Tully",
        "uniformNumber": 43,
        "bats": "R",
        "throws": "R",
        "primaryPosition": 5,
        "primaryBattingOrder": 10
      },
      "battingOrder": 10,
      "startingPosition": 7,
      "substitutions": []
    },
    {
      "player": {
        "id": 1788128322013,
        "name": "Jordan ",
        "uniformNumber": 17,
        "bats": "R",
        "throws": "R",
        "primaryPosition": 1,
        "primaryBattingOrder": 11
      },
      "battingOrder": 11,
      "startingPosition": 5,
      "substitutions": []
    }
  ]
  return rocks
}
